import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
// import authentication from './modules/authentication'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	/* modules: {
	  auth:authentication
	}, */
	state: {
		navigate: true,
		layout: '',
		uobj: null,
		userdata: null,
		fcmt: null,
		alertMessage: {
			msg: '',
			class: '',
			persistent: false
		},
		// videocall
		ringing: false,
		callStatus: 'disconnected',
		videocallPayload: null,
		minimised: false,
		notificationCount: 0,
		notifications: [],
		socket: null,
	},
	actions,
	mutations,
	getters,
	strict: debug
  })
  export function createStore() {
	return store
  }
  //  For inheriting in other modules
  export default store